'use strict';

var magnificPopup = require('../lib/magnific-popup.js');
var getUrlId = require('../lib/getUrlId.js');
var $ = window.jQuery;

function init() {
	var $triggers = $('.isOpenInLightbox');
	if (!$triggers.length)
		return;

	$triggers.each(function(index, element) {
		var source = getUrlId(element.href);
		$(element).magnificPopup({
			mainClass: 'lightbox',
			items: {
				src: source,
				type: 'inline',
			},
			closeMarkup: '<button title="%title%" type="button" class="lightbox__close mfp-close"></button>'
		});
	});
}
module.exports = {
	init: init
}
